import React from 'react';
import TopicContent from '../../BasicComponents/TopicContent';

const TenantLaunchpadContent = () => {
  return <TopicContent mode="tenant" />;
};

export default TenantLaunchpadContent;
